export default __webpack_public_path__ + "fonts/iconfont.4aad13777c64277622bc32d27ec9a5ed.svg";